import React from "react";
import { Button, Card, Divider, Select } from "antd";

const { Option } = Select;

const infoStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 12,
  fontSize: 12,
  fontFamily: "Inter",
};
const labelStyle = { color: "#8c8c8c" };

export default function UserInfoPanel({ ticket, onStatusChange }) {
  if (!ticket) return null;

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <Card
          //   title="Ticket Actions"
          style={{
            borderRadius: 8,
            boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          }}
        >
          <p
            className="fw-semibold"
            style={{ fontFamily: "Inter", marginBottom: 5 }}
          >
            Ticket Actions
          </p>
          <Select
            value={ticket.status}
            style={{ width: "100%" }}
            onChange={(value) => onStatusChange(ticket.id, value)}
          >
            <Option value="OPEN">Open</Option>
            <Option value="IN_PROGRESS">In Progress</Option>
            <Option value="RESOLVED">Resolved</Option>
            <Option value="CLOSED">Closed</Option>
          </Select>
        </Card>

        {/* user info */}
        <Card
          style={{
            borderRadius: 8,
            boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              marginBottom: 16,
              display: "flex",
              justifyContent: "space-between",
              fontFamily: "Inter",
            }}
          >
            User Details
          </div>
          <div style={infoStyle}>
            <span style={labelStyle}>Name</span>{" "}
            <span>
              {ticket?.user?.firstName} {ticket?.user?.lastName}
            </span>
          </div>
          <div style={infoStyle}>
            <span style={labelStyle}>Email</span>{" "}
            <span>{ticket?.user?.email}</span>
          </div>
          <div style={infoStyle}>
            <span style={labelStyle}>Phone</span>{" "}
            <span>{ticket?.user?.phone}</span>
          </div>

          <Divider />

          <div
            style={{
              fontWeight: 600,
              marginBottom: 16,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            Meta
          </div>
          <div style={infoStyle}>
            <span style={labelStyle}>Source</span>{" "}
            <span>{ticket.sourceApp}</span>
          </div>
          <div style={infoStyle}>
            <span style={labelStyle}>Created</span>{" "}
            <span>{new Date(ticket.createdAt).toLocaleString()}</span>
          </div>
        </Card>
      </div>
    </>
  );
}
